import { breakpointKeys } from 'src/js/modules/element-settings/constants/breakpoints';
import { targetClasses } from 'src/js/modules/element-settings/constants/target-classes';

const paddingDefaults = {
  [breakpointKeys.DEFAULT]: {
    [targetClasses.PADDING_TOP]: '32px',
    [targetClasses.PADDING_BOTTOM]: '32px',
    [targetClasses.COL_PADDING_LEFT]: '40px',
    [targetClasses.COL_PADDING_RIGHT]: '40px',
  },
  [breakpointKeys.MAX_XL]: {
    [targetClasses.PADDING_TOP]: '28px',
    [targetClasses.PADDING_BOTTOM]: '28px',
    [targetClasses.COL_PADDING_LEFT]: '36px',
    [targetClasses.COL_PADDING_RIGHT]: '36px',
  },
  [breakpointKeys.MAX_MD]: {
    [targetClasses.PADDING_TOP]: '24px',
    [targetClasses.PADDING_BOTTOM]: '24px',
    [targetClasses.COL_PADDING_LEFT]: '32px',
    [targetClasses.COL_PADDING_RIGHT]: '32px',
  },
};

export default paddingDefaults;
